/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CancelCeremonyRequestDto
 */
export interface CancelCeremonyRequestDto {
    /**
     * Created or processed Workflow instance Id
     * @type {string}
     * @memberof CancelCeremonyRequestDto
     */
    workflowInstanceId: string;
}

/**
 * Check if a given object implements the CancelCeremonyRequestDto interface.
 */
export function instanceOfCancelCeremonyRequestDto(value: object): boolean {
    if (!('workflowInstanceId' in value)) return false;
    return true;
}

export function CancelCeremonyRequestDtoFromJSON(json: any): CancelCeremonyRequestDto {
    return CancelCeremonyRequestDtoFromJSONTyped(json, false);
}

export function CancelCeremonyRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelCeremonyRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'workflowInstanceId': json['workflowInstanceId'],
    };
}

export function CancelCeremonyRequestDtoToJSON(value?: CancelCeremonyRequestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workflowInstanceId': value['workflowInstanceId'],
    };
}

